import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getSystemInfo = (params, urlParams) => {
  return axios.request({
    url: '/ops/systeminfo/getsysteminfo' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

